import { MutationTree } from "vuex";
import { PaymentRequirementsCardIndexDetailsItem, PaymentRequirementsItem } from "../../api/incoming/payment-requirements-incoming.interface";
import { PaymentRequirementsIncomingMutation } from "./constants";
import { PaymentRequirementsIncomingState } from "./interface";

export default <MutationTree<PaymentRequirementsIncomingState>> {

	[PaymentRequirementsIncomingMutation.setUnprocessedList](
		state,
		payload: PaymentRequirementsItem[]
	) {
		state.unprocessedList = payload;
	},

	[PaymentRequirementsIncomingMutation.setUnprocessedListLoading](
		state,
		payload: boolean
	) {
		state.unprocessedListLoading = payload;
	},

	[PaymentRequirementsIncomingMutation.setUnprocessedListShowed](
		state,
		payload: boolean
	) {
		state.unprocessedListShowed = payload;
	},

	[PaymentRequirementsIncomingMutation.setCardIndexDetails](
		state,
		payload: PaymentRequirementsCardIndexDetailsItem | null
	) {
		if (!payload)
			state.cardIndexDetails = {};
		else if (payload.documentIdInk)
			state.cardIndexDetails[payload.documentIdInk] = payload;
	},

}